var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSuccessToast, showErrorToast } from '@ui';
import { translate } from '@utils/i18n';
import { createSprinklerSampleSubmission } from '../services/SprinklerSamplingService';
import { sprinklerSamplingKeys } from './queryKeys';
import { NAMESPACE } from '../constants';
export function useSprinklerSamplingMutation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ buildingId, formData }) {
            var _b;
            const response = yield createSprinklerSampleSubmission(buildingId, formData);
            if (response.error) {
                throw new Error(((_b = response.error.errors) === null || _b === void 0 ? void 0 : _b.join(', ')) || response.error.message);
            }
        }),
        onSuccess: (_, variables) => {
            showSuccessToast(translate('form.success', { namespace: NAMESPACE }));
            // Invalidate all table queries for this building to refetch data
            void queryClient.invalidateQueries({
                queryKey: sprinklerSamplingKeys.all
            });
        },
        onError: (error) => {
            showErrorToast(error.message || translate('form.error', { namespace: NAMESPACE }));
        }
    });
}
